import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { getDomain } from '@bingads-webui/url-util';

import { CreativeEditorImageSuggestion } from './image-suggestion-carousel';
import { ImageContainer } from './basic-item';

export const ImageChooser = ({
  i18n,
  currentImage,
  cid,
  aid,
  oDataConfig,
  finalUrl,
  onChangeImage,
  assetLibraryConfig,
  showHelpPopup,
  helpTopic,
  onLoadingImage,
}) => {
  const [displayImageSuggestions, setDisplayImageSuggestions] = useState(false);

  const isTestEnv = useMemo(() => getDomain(window.location.href) === 'localhost', []);

  return (
    <div>
      {
        currentImage &&
        <ImageContainer
          onLoadingImage={onLoadingImage}
          currentImage={currentImage}
          isTestEnv={isTestEnv}
          title={i18n.getString(_TL_('Image'))}
          showHelpPopup={showHelpPopup}
          helpTopic={helpTopic}
          i18n={i18n}
          displayEdit={!displayImageSuggestions}
          onEdit={() => { setDisplayImageSuggestions(true); }}
        />
      }
      {
          displayImageSuggestions &&
          <CreativeEditorImageSuggestion
            cid={cid}
            aid={aid}
            oDataConfig={oDataConfig}
            url={finalUrl}
            hasErrorInUrl={false}
            onChangeImage={onChangeImage}
            assetLibraryConfig={assetLibraryConfig}
          />
        }
    </div>
  );
};

ImageChooser.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  currentImage: PropTypes.string,
  cid: PropTypes.string.isRequired,
  aid: PropTypes.string.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  finalUrl: PropTypes.string.isRequired,
  onChangeImage: PropTypes.func.isRequired,
  assetLibraryConfig: PropTypes.shape({}).isRequired,
  onLoadingImage: PropTypes.func,
  showHelpPopup: PropTypes.bool,
  helpTopic: PropTypes.string,
};

ImageChooser.defaultProps = {
  showHelpPopup: false,
  helpTopic: '',
  currentImage: '',
  onLoadingImage: () => {},
};
